import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';


const Reference: React.FC<{
    name: string,
    position: string,
    company: string,
    phone: string,
    email: string,
}> = ({ name, position, company, phone, email }) => {

    return (
        <Box
            sx={{
                fontSize: '0.9em',
                flexGrow: 1,
            }}
        >
            <h4 style={{ margin: 0, marginTop: '5px', marginBottom: '5px' }}>{name}</h4>
            <p style={{ margin: 0 }}>{position}</p>
            <p style={{ margin: 0 }}>{company}</p>
            <p style={{ margin: 0, marginTop: '10px' }}><b>Phone:</b> {phone}</p>
            <p style={{ margin: 0 }}><b>Email:</b> {email}</p>
        </Box>
    )
}

export { Reference };